module.exports = __webpack_public_path__ + "media/images/drop-1ed64378375991dfcbbc5720574cffe2cb36c3f9ac3fe908f0bfdae652890f77.svg";